import Vue from 'vue'
import Vuex from 'vuex'
import textLoader from './textLoader'
import gameState from './gameState'
import wrecks from './wrecks'
import experts from './experts'
import actions from './actions'
import documents from './documents'
import evidence from './evidence'
import maps from './maps'
//import userData from './userData'
import wreckNodes from './wreckNodes'
import interfaceState from './interface'
import notifications from './notifications'
import player from './player'
import user from './user'
import artefacts from './artefacts'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    textLoader:textLoader,
    gameState:gameState,
    wrecks:wrecks,
    experts:experts,
    actions:actions,
    documents:documents,
    evidence:evidence,
    maps:maps,
    artefacts:artefacts,
    //userData:userData,
    wreckNodes:wreckNodes,
    interfaceState:interfaceState,
    player:player,
    notifications,
    user:user
  },
  
})
